export default __webpack_public_path__ + "static/media/check_icon.af362908.svg";